<div class="content">
  <button mat-icon-button class="close-button bg-transparent" mat-dialog-close>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
  <div class="text-center mat-dialog-title">Letöltés</div>
  <div class="cards">
    <mat-card>
      <p class="font-weight-bold">Legújabb szoftver</p>
      <p>filename</p>
      <button class="btn btn-primary">Letöltés</button>
    </mat-card>
    <mat-card>
      <p class="font-weight-bold">Felhasználói kézikönyv</p>
      <p>filename</p>
      <button class="btn btn-primary">Megnyitás</button>
    </mat-card>
  </div>
</div>
